module.exports = __webpack_public_path__ + "static/media/atharv_munot.6b0fb3dc.png";